<template>
  <div id="history-risk">
    <b-table
      :items="records"
      :fields="fields"
      :busy="loadingHistory"
      class="table-history-risk"
    >
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <OverlayButton clase="overlay-md"></OverlayButton>
        </div>
      </template>
      <template #row-details="row">
        <b-table :items="row.item.details" style="background-color: #f3f3f3" />
      </template>
    </b-table>
    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
      <Pagination
        :data="tableHistory"
        :limit="10"
        @pagination-change-page="paginateHistory"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
import { historyRisk } from "@/services/health-tracker/ges/service";
export default {
  components: {
    OverlayButton,
    Pagination,
  },
  data() {
    return {
      id: this.$route.params.id,
      records: [],
      fields: [
        { key: "modification_type", label: "Tipo" },
        { key: "date", label: "Fecha" },
        { key: "columna", label: "Modificación" },
        { key: "valor_anterior", label: "Valor Anterior" },
        { key: "valor_nuevo", label: "Valor Nuevo" },
      ],
      loadingHistory: false,
      page: 1,
      tableHistory: {},
    };
  },
  methods: {
    async loadHistory() {
      const me = this;
      me.loadingHistory = true;
      try {
        const { data } = await historyRisk(me.id, { page: me.page });
        me.tablePerson = data;
        data.data.forEach((x) => {
          me.records.push({
            id: x.id,
            modification_type: x.modification_type,
            date: x.date,
            columna: x.history[0].columna,
            valor_anterior: x.history[0].valor_anterior,
            valor_nuevo: x.history[0].valor_nuevo,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingHistory = false;
      }
    },
    paginateHistory(page) {
      const me = this;
      me.page = page;
      me.loadHistory();
    },
  },
  mounted() {
    const me = this;
    me.loadHistory();
  },
};
</script>

<style lang="scss" scoped>
.table-history-risk {
  box-shadow: 0 0 4px 2px transparent !important;
  border-radius: 0 !important;
}
</style>
